import { render } from "./Markdown.vue?vue&type=template&id=671d8676"
import script from "./Markdown.vue?vue&type=script&lang=js"
export * from "./Markdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__